/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * ProgressiveAddressMismatch Input Action
 */
export class ProgressiveAddressMismatchInput implements Msdyn365.IActionInput {
    // ProgressiveAddressMismatchInput: Construct the input needed to run the action
    constructor() {}
    public getCacheKey = () => `ProgressiveAddressMismatchInput`;
    public getCacheObjectType = () => 'ProgressiveAddressMismatchInput';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// ProgressiveAddressMismatchInput: Create a data model here or import one to capture the response of the action
export interface IProgressiveAddressMismatchData {
    misMatch: boolean;
}

/**
 * ProgressiveAddressMismatchInput: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new ProgressiveAddressMismatchInput();
};

/**
 * ProgressiveAddressMismatchInput: Use this function to call your action and process the results as needed
 */
async function action(input: ProgressiveAddressMismatchInput, ctx: Msdyn365.IActionContext): Promise<IProgressiveAddressMismatchData> {
    return { misMatch: false};
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IProgressiveAddressMismatchData>>action,
    // ProgressiveAddressMismatchInput: Give your data action a unique id
    id: 'ProgressiveAddressMismatch',
    input: createInput
    // ProgressiveAddressMismatchInput: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
